import { Buy } from "./buy";
import { BuyOutline } from "./buy-outline";
import { Cart } from "./cart";
import { CartWithBG } from "./cart-with-bg";
import { CheckWithBG } from "./check-with-bg";
import { Wallet } from "./wallet";
import { ArrowForward } from "./arrow-forward";
import { Instagram } from "./instagram";
import { WhatsApp } from "./whatsapp";
import { LinkedIn } from "./linkedin";
import { Check } from "./check";
import { Facebook } from "./facebook";
import { FolderWithBG } from "./folder-with-bg";
import { Logistics } from "./logistics";
import { Market } from "./market";
import { Package } from "./package";
import { Ship } from "./ship";
import { Store } from "./store";
import { Twitter } from "./twitter";
import { Eye } from "./eye";
import { EyeOff } from "./eye-off";
import { Menu } from "./menu";
import { Settings } from "./settings";
import { SearchWithBG } from "./search-with-bg";
import { User } from "./user";
import { Notification } from "./notification";
import { NoteWithBG } from "./note-with-bg";
import { TrendUp } from "./trend-up";
import { Coins } from "./coins";
import { MoneyIcon } from "./money";
import { ArrowUp } from "./arrow-up";
import { AirplanIcon } from "./airplane";
import { Info } from "./info";
import { UsersFour } from "./users-four";
import { RewardIcon } from "./reward";
import { Tracker } from "./tracker";
import { DollarSign } from "./dollar-sign";
import { Calculator } from "./calculator";
import { ArrowRight } from "./arrow-right";
import { Bell } from "./bell";
import { Blog } from "./blog";
import { BookMark } from "./bookmark";
import { Calender } from "./calender";
import { Cancel } from "./cancel";
import { ChatIcon } from "./chat";
import { GoogleMeet } from "./google-meet";
import { Zoom } from "./zoom";
import { ApproxEqualsIcon } from "./ApproxEqualsIcon";

export const iconsMap = {
  airplane: <AirplanIcon />,
  arrowForward: <ArrowForward />,
  arrowRight: <ArrowRight />,
  arrowUp: <ArrowUp />,
  bell: <Bell />,
  blog: <Blog />,
  bookMark: <BookMark />,
  buy: <Buy />,
  buyOutline: <BuyOutline />,
  calculator: <Calculator />,
  calender: <Calender />,
  cancel: <Cancel />,
  cart: <Cart />,
  cartWithBg: <CartWithBG />,
  chat: <ChatIcon />,
  check: <Check />,
  checkWithBg: <CheckWithBG />,
  coins: <Coins />,
  deposits: <ArrowUp />,
  dollarSign: <DollarSign />,
  eye: <Eye />,
  eyeOff: <EyeOff />,
  facebook: <Facebook />,
  folderWithBG: <FolderWithBG />,
  googleMeet: <GoogleMeet />,
  instagram: <Instagram />,
  info: <Info />,
  linkedin: <LinkedIn />,
  logistics: <Logistics />,
  market: <Market />,
  menu: <Menu />,
  money: <MoneyIcon />,
  notification: <Notification />,
  noteWithBG: <NoteWithBG />,
  package: <Package />,
  reward: <RewardIcon />,
  settings: <Settings />,
  searchWithBG: <SearchWithBG />,
  ship: <Ship />,
  store: <Store />,
  twitter: <Twitter />,
  trend: <TrendUp />,
  user: <User />,
  users: <UsersFour />,
  whatsapp: <WhatsApp />,
  wallet: <Wallet />,
  withdrawals: <ArrowUp className="-rotate-90" />,
  tracker: <Tracker />,
  zoom: <Zoom />,
  approxEquals: <ApproxEqualsIcon />,
};
